module.exports = __webpack_public_path__ + "img/person-select-bg.a540e8c0.png";